import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { MenuItemsState, MenuItem } from '../../components/menuItems/types';

const initialState: MenuItemsState = {
  items: [],
  loading: false,
  error: null,
};

const menuItemsSlice = createSlice({
  name: 'menuItems',
  initialState,
  reducers: {
    // Fetch menu items
    fetchMenuItemsRequest(state, action: PayloadAction<{ restaurantId: string }>) {
      state.loading = true;
      state.error = null;
    },
    
    fetchMenuItemsSuccess(state, action: PayloadAction<MenuItem[]>) {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    
    fetchMenuItemsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    
    clearMenuItems(state) {
      state.items = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchMenuItemsRequest,
  fetchMenuItemsSuccess,
  fetchMenuItemsFailure,
  clearMenuItems,
} = menuItemsSlice.actions;

export default menuItemsSlice.reducer;
